import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import { GetServiceSetData } from "../../../../Api/ServiceDatas";
import RadioBtn from "../../../Button/RadioBtn";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import { selectedAccountIdAtom } from "./PreviewSection";

interface SelectAccountModalProps extends DefaultModalCommonProps {
  accountList: [];
}

interface IAccountList {
  id: string;
  partyid?: string[];
  servid: number;
}

export default function SelectAccountModal({
  closeEvent,
  accountList,
}: SelectAccountModalProps) {
  const setSelectedAccounId = useSetRecoilState(selectedAccountIdAtom);

  let obj: any = {};

  for (let i = 0; i < accountList?.length ?? 0; i++) {
    const element = accountList[i] as any;

    obj[element.id] = false;
  }

  const [check, setCheck] = useState(obj);

  type checkType = typeof check;

  console.log(check);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        const selectedId = Object.keys(check).find(
          (key) => check[key] === true
        );

        setSelectedAccounId(selectedId ?? "");
        closeEvent();
      }}
      modalTitle="임시 계정 선택"
      isMediumModal={true}
    >
      <>
        <ModalContent>
          <LabelColumn>
            <ModalLabel style={{ height: "auto" }}>계정 선택</ModalLabel>
            <ModalLabel style={{ height: "auto", marginTop: 20 }}>
              PID(UID)
            </ModalLabel>
          </LabelColumn>

          <AccountList>
            {accountList?.map((a: IAccountList) => {
              const partyList = a?.partyid as string[];
              const servData = GetServiceSetData(a?.servid)[0];

              const objByDetail = partyList.reduce(
                (group: any, product: any) => {
                  const pid = product?.split("_")[0] ?? "";

                  group[pid] = group[pid] ?? [];
                  group[pid].push(
                    `${product?.split("_")[1]}_${product?.split("_")[2]}`
                  );

                  return group;
                },
                {}
              );

              const arrByDetail = Object.entries(objByDetail) as [
                string,
                string[]
              ][];

              return (
                <AccountItem key={a?.id}>
                  <RadioBtn
                    label={`${servData?.SVC_NMKR_TEMP}_${a?.id}`}
                    check={check[a?.id as keyof checkType] ?? false}
                    noTooltip={true}
                    clickEvent={() => {
                      setCheck({
                        ...obj,
                        [a?.id]: !check[a?.id as keyof checkType],
                      });
                    }}
                  />

                  {arrByDetail?.length > 0 ? (
                    arrByDetail?.map((data, index: number) => {
                      const uidList = data[1] as string[];

                      return (
                        <PartyStateBox key={index}>
                          {data[0]}(
                          {uidList?.map(
                            (d: string, i: number) =>
                              `${d?.split("_")[0]}` +
                              (i + 1 === uidList?.length ? `` : `,`)
                          )}
                          ) 대여중
                        </PartyStateBox>
                      );
                    })
                  ) : (
                    <PartyStateBox>대여 가능</PartyStateBox>
                  )}
                </AccountItem>
              );
            })}
          </AccountList>
        </ModalContent>
      </>
    </DefaultModalLayout>
  );
}

const ModalContent = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const LabelColumn = styled.div``;

const AccountList = styled.div`
  width: 100%;
`;

const AccountItem = styled.div`
  margin-right: 16px;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const PartyStateBox = styled.div`
  margin-left: 28px;
  margin-top: 12px;
  width: 100%;
  height: 38px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 10px 16px;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray500};
`;
